import React, { Component } from 'react';
import ButtonIcon from '../../../../button';
import { Selected_Index } from '../../../../../constants/external-constants';
import { ListTabButton } from '../../../../common/list-tab/list-tab-button.component';

import ContractFormView from '../contract-form/contract-form.component';
import ContractComment from '../contract-comment/contract-comment.component';
import ContractHistory from '../contract-history/contract-history.component';
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../../utils/helpers.utils";

class ContractView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: "0",
            listTab: [
                {
                    "id": Selected_Index.i_Zero,
                    "label": "Details",
                    "hidden": false
                },
                {
                    "id": Selected_Index.i_One,
                    "label": "Comments",
                    "hidden": false,   
                    "disable": true
                },
                {
                    "id": Selected_Index.i_Two,
                    "label": "History",
                    "hidden": false,
                    "disable": true
                },
            ],
        }
    }

    FilterIndex = (index) => {
        this.setState({ selectedIndex: index });
    }
    handleCloseForm = () => {
        const { closeFormAction, } = this.props;
        closeFormAction();
    }

    renderTabContent = (index) => {
        this.setState({ selectedTab: index });
    }

    activeListTab = (listTab) => {

        return listTab.map(item => {
            var disabled = item.disable;
            if ((item.id == Selected_Index.i_One || item.id == Selected_Index.i_Two) && this.props.contractId > 0) {
                 disabled = false;
             }

            return {
                ...item,
                disable: disabled
            };
        })
    }

    render() {
        const { listTab, selectedIndex } = this.state;        
        const { contractId } = this.props
        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceContractDashboardR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceContractDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceContractDashboardRW])

        return (
            <div className="layout-container">
                <ButtonIcon onClick={this.handleCloseForm} iconLeft="chevron-left" iconSize="17px" customClassName="manage-invoice-back-button" labelName="Back" />
                {listTab ? <ListTabButton listData={this.activeListTab(listTab)} selectedIndex={selectedIndex} FilterIndex={this.FilterIndex} /> : null}
                <div className={"details-container add-plan-catalogue"}>
                    {selectedIndex === Selected_Index.i_Zero &&
                        (
                        <ContractFormView
                            isReadAndWrite={isReadAndWrite}
                            contractId={this.props.contractId}
                            isCreateNew={this.props.isCreateNew}
                            handleCloseForm={this.handleCloseForm}
                        />
                        )
                     }
                    {selectedIndex === Selected_Index.i_One && 
                        (
                            <ContractComment
                            financeContractID={contractId}
                            isReadOnly={isReadOnly}
                            isReadAndExtractOnly={isReadAndExtractOnly}
                            isReadAndWrite={isReadAndWrite}
                            isCreateNew = {false}
                            />
                        )
                    }
                    {selectedIndex === Selected_Index.i_Two &&
                        (
                            <ContractHistory
                            contractId={this.props.contractId}
                            //Access Type
                            isReadOnly={isReadOnly}
                            isReadAndExtractOnly={isReadAndExtractOnly}
                            isReadAndWrite={isReadAndWrite}
                            isCreateNew = {false}
                            />
                        )
                    }

                </div>

            </div>
        );
    }
}

export default ContractView;